<template>
  <extensions-permission-guard :situation-id="situationId">
    <v-container fluid>
      <v-row>
        <v-col cols="12" lg="6" offset-lg="1">
          <h2 class="title mb-3">メルマガ会員一覧</h2>
          <permission-guard situation="mail_magazine_member_management">
            <v-simple-table fixed-header>
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">登録メールアドレス</th>
                  <th class="text-center">配信ステータス</th>
                  <th class="text-center">登録日</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="member in mailMagazineMembers" :key="member.id">
                  <td>{{ member.id }}</td>
                  <td>{{ member.email }}</td>
                  <td class="text-center">
                    <v-chip v-if="member.delivered == true" small color="success">
                      配信中
                    </v-chip>
                    <v-chip v-else small color="error">
                      停止中
                    </v-chip>
                  </td>
                  <td>{{ member.registerConfirmedAt | momentDatetime }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <infinite-loading
              spinner="spiral"
              class="mt-2"
              @infinite="infiniteHandler"
            >
              <template v-slot:no-more>
                <v-chip label outlined> 全て表示されました。 </v-chip>
              </template>
              <template v-slot:no-results>
                <v-chip label outlined> 表示できるものがありません。 </v-chip>
              </template>
            </infinite-loading>
          </permission-guard>
        </v-col>
      </v-row>
    </v-container>
  </extensions-permission-guard>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import InfiniteLoading from 'vue-infinite-loading'
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { MAIL_MAGAZINE_MEMBERS_SITUATION_ID } from '@/mixins/site_permission_utils'
import PermissionGuard from '@/components/commons/PermissionGuard'
import moment from 'moment'

export default {
  components: { InfiniteLoading, ExtensionsPermissionGuard, PermissionGuard },
  data: () => {
    return {
      pageTitle: 'メルマガ会員一覧',
      page: 1,
      mailMagazineMembers: [],
      situationId: MAIL_MAGAZINE_MEMBERS_SITUATION_ID
    }
  },
  filters: {
    momentDatetime: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D HH:mm')
      }
    }
  },
  methods: {
    infiniteHandler ($state) {
      axios
        .get('/api/mail_magazine_members', {
          params: {
            page: this.page
          }
        })
        .then(
          ({ data }) => {
            const fetchedMailMagazineMembers = deserialize(data).data

            if (fetchedMailMagazineMembers.length > 0) {
              this.page++
              this.mailMagazineMembers = this.mailMagazineMembers.concat(fetchedMailMagazineMembers)
              $state.loaded()
            } else {
              $state.complete()
            }
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>
